import { Amplify } from 'aws-amplify';

// Configure Amplify with Cognito settings
const amplifyConfig = {
    Auth: {
        Cognito: {
            userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
            userPoolClientId: process.env.REACT_APP_COGNITO_APP_CLIENT_ID,
            region: process.env.REACT_APP_COGNITO_REGION || 'us-east-1'
        }
    }
};

// Only configure if Cognito settings are provided
if (process.env.REACT_APP_COGNITO_USER_POOL_ID && process.env.REACT_APP_COGNITO_APP_CLIENT_ID) {
    Amplify.configure(amplifyConfig);
    console.log('Amplify configured with Cognito');
} else {
    console.log('Cognito not configured - using JWT auth');
}

export default amplifyConfig;
